module.exports = __webpack_public_path__ + "static/media/bottomArrow.2703c0b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/BottomArrow/bottomArrow.svg
// module id = 890
// module chunks = 21